import { type ControllerApiConstructor } from './abstract'
import { AbstractSelfInitSdk } from './abstractSelfInit'
import { Catch } from './catchError'
import {
  type DisruptionsCountOutput,
  TrafficInfoControllerApi,
  type TrafficInfoDetails,
  type TrafficInfoOutput,
} from './generated'

export class TrafficInfoSdk extends AbstractSelfInitSdk<TrafficInfoControllerApi> {
  protected getControllerApiConstructor(): ControllerApiConstructor<TrafficInfoControllerApi> {
    return TrafficInfoControllerApi
  }

  @Catch<DisruptionsCountOutput>()
  async getDisruptionsCount(): Promise<DisruptionsCountOutput> {
    return (await this.api.disruptionsCount(this.userSdk.getBffHeader(), this.userSdk.createAxiosOptions())).data
  }

  @Catch<TrafficInfoDetails>()
  async getNetworkTrafficInfo(network: string): Promise<TrafficInfoDetails> {
    return (await this.api.trafficInfoDetails(network, this.userSdk.getBffHeader(), this.userSdk.createAxiosOptions()))
      .data
  }

  @Catch<TrafficInfoOutput>()
  async getTrafficInfo(): Promise<TrafficInfoOutput> {
    return (await this.api.trafficInfo(this.userSdk.getBffHeader(), this.userSdk.createAxiosOptions())).data
  }
}
